import React from "react";
import { Modal, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export const ModalComponent = (props) => {
  return (
    <Modal
      open={props?.Open}
      onClose={props.HandleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      disableEscapeKeyDown={true}
      disableScrollLock={false}
    >
      {/* <Box sx={{borderRadius: "4px !important"}} className={`${props.ClassName} modal `}>
        <Box className="modal-body">
          {props.Body()}
        </Box>
      </Box> */}
      <div className="modal fade show" tabindex="-1">
        <div className={`${props.ClassName} modal-dialog modal-dialog-scrollable `}>
          <div className="modal-content">
            <div className="modal-body">
              {props.Body()}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
